<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <section class="wizard">
    <div class="form-container form-container--notfirst">
      <slot :current-step="currentStep" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Wizard',
  props: {
    firstStep: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentStep: '',
    };
  },
  mounted() {
    this.currentStep = this.firstStep;
  },
  methods: {
    goToStep(stepName) {
      this.$formulate.resetValidation(stepName);
      this.currentStep = stepName;
      this.scrollToTop();
    },
    scrollToTop() {
      const appElement = document.querySelector('#app');
      if (appElement) {
        appElement.scrollIntoView({});
      }
    },
  },
};
</script>
